<div class="page-wrapper" [class.expand-side-menu]="isMenuOpen()">
 @if(!loginPath) {
    <ng-container>
      <lib-header></lib-header>
      @if(isMenuOpen()) {
        <app-side-menu/>
      }
    </ng-container>
  }
 
  <div class="main-content">
    <router-outlet></router-outlet>
  </div>
</div>